// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"33411f69391928fa3e345c3d54dfe2d468562f76"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.4.2";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://687dc1fa894a40dda48fdc10e16535e1@o245864.ingest.sentry.io/5665871',
  environment: process.env.NEXT_PUBLIC_ENV,
  attachStacktrace: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  tracesSampleRate: 0.1,
});
